import { Query } from '@apollo/client/react/components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router';
import { Loading } from '../../components';
import { DatesForNewSurveyQuery, OrganizationQuery, UserQuery } from '../../generated/hooks';
import { getDatesForNewSurvey, getUserQuery } from '../../graphql/queries';
import { CreateSurveyForm } from './CreateSurveyForm';

export type BaseSurveyProps = RouteComponentProps<any> & {
  user: UserQuery['user'];
  organization: OrganizationQuery['organization'];
  subjectLabel: string;
  subjectId: string;
  subjectType: string;
};

const NewDatesLoader = (props: BaseSurveyProps) => {
  return (
    <Query<DatesForNewSurveyQuery>
      variables={{ organizationId: props.user.organization!.id }}
      query={getDatesForNewSurvey}
      fetchPolicy="network-only"
    >
      {({ loading, error, data }) => {
        if (loading) {
          return <Loading />;
        }
        if (error) {
          return <></>;
        }
        if (data && data.datesForNewSurvey) {
          return <CreateSurveyForm {...props} datesForNewSurvey={data.datesForNewSurvey} />;
        }
        return null;
      }}
    </Query>
  );
};

const CreateSurveyScreen = (props: RouteComponentProps<any>) => {
  const {
    match: { params },
  } = props;
  const { i18n } = useTranslation('surveyForm');
  const [language, setLanguage] = useState<string>(i18n.language);
  let refetchFn: (a?: any) => any = () => null;

  useEffect(() => {
    setLanguage(i18n.language);
    refetchFn({ languageCode: i18n.language });
  }, [i18n.language]);

  return (
    <Query<UserQuery> variables={{ languageCode: language }} query={getUserQuery}>
      {({ loading, error, data, refetch }) => {
        refetchFn = refetch;
        if (loading) {
          return <Loading />;
        }
        if (error) {
          return <></>;
        }
        if (data && data.user && data.user.organization) {
          return <NewDatesLoader {...params} {...props} user={data.user} />;
        }
        return null;
      }}
    </Query>
  );
};

export default CreateSurveyScreen;
